module.exports = " <div class=\"button pointer-hover\" transition=reveal _v-5c9188f2=\"\"> <symbol name=arrow-back-left _v-5c9188f2=\"\"></symbol> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5c9188f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackButton.vue
// module id = 763
// module chunks = 2